<div class="expired-peding-unmounting-items-container">

  <div class="filter-header-container">
    <!-- Left: Header -->
    <div class="filter-title">
      <h3>Expired Pending Unmounting Items</h3>
    </div>

    <!-- Right: Date Filters -->
    <ul class="filter-actions cinline-block">
      <li class="sites-from-text">
        <div>From</div>
      </li>
      <li class="margin-top-5">
        <p-calendar [styleClass]="'site-from-button-hm'" dateFormat="ddMy" appendTo="body" placeholder="Ex-01Jan18"
          (onInput)="onDateSelection($event,true)" (onSelect)="onDateSelection($event,true)" [(ngModel)]="startDate"
          [utc]="true" [showIcon]="true" #stDate="ngModel" [maxDate]="eDate.value" name="stDate"></p-calendar>
      </li>

      <li class="sites-from-text">
        <div>To</div>
      </li>
      <li class="margin-top-5">
        <p-calendar [styleClass]="'site-from-button-hm'" dateFormat="ddMy" appendTo="body" [disabled]="!startDate"
          placeholder="Ex-01Jan18" (onInput)="onDateSelection($event,false)" (onSelect)="onDateSelection($event,false)"
          [(ngModel)]="endDate" [utc]="true" [showIcon]="true" [minDate]="stDate.value" [maxDate]="maxValidDateForSelection"
          #eDate="ngModel" name="eDate"></p-calendar>
      </li>
    </ul>
  </div>

  <div class="grid-container">
    <form [formGroup]="pendingUnmountingGroup">
      <sib-grid #sibGrid [columns]="columns" [config]="gridConfig" [totalRecords]="totalRecords"
        formControlName="gridControl" ngDefaultControl>

      </sib-grid>
    </form>
  </div>
</div>